export const GET_ALL_CITY = `query GetAllCity($input: TcityWhereInput, $skip: Float, $take: Float) {
  getCity(where: $input, skip: $skip, take: $take) {
    items {
      id
      name
      note
      provinceId
      tdistricts {
        id
        name
      }
    }
  }
}
`;

export const GET_ALL_DISTRICT = `query GetDistrictByCity($input: TdistrictWhereInput, $skip: Float, $take: Float) {
  getDistrict(where: $input, skip: $skip, take: $take) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      name
      note
    }
  }
}
`;

export const GET_ALL_WARD = `query GetAllWardByDistrict($input: TwardWhereInput, $skip: Float, $take: Float) {
  getWard(where: $input, skip: $skip, take: $take) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      name
      note
    }
  }
}`;

export const GET_ALL_WARD_BY_LIST_DISTRICT = `
query GetWardByDistrict($input: TdistrictWhereInput, $skip: Float, $take: Float) {
  getDistrict(where: $input, skip: $skip, take: $take) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      name
      twards{
        id
        name
      }
    }
  }
}`;

export const GET_ALL_DISTRICT_BY_LIST_CITY = `
query GetAllCity($input: TcityWhereInput, $skip: Float, $take: Float) {
  getCity(where: $input, skip: $skip, take: $take) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      name
      note
      provinceId
      tdistricts {
        id
        name
      }
    }
  }
}`;
